import { ListingDetailMiddleSection } from '@components/programme/ListingDetailMiddleSection';
import { ListingDetailTopSection } from '@components/programme/ListingDetailTopSection';
import { RelatedContent } from '@components/relatedContent/RelatedContent';

import {
	ElsewherePresentsVenueRecord,
	ProgrammeDetail,
	SpacePreviewData,
	SupabaseEventRecord,
} from '@interfaces';

import styles from './listing-detail.module.scss';
import { ListingAdditionalMicrodata } from './ListingAdditionalMicrodata';
import { ListingThumbnail } from './ListingThumbnail';

interface ListingDetailProps {
	event: SupabaseEventRecord;
	programmeData: ProgrammeDetail;
	relatedEvents: SupabaseEventRecord[];
	space?: SpacePreviewData;
	elsewherePresentsVenue?: ElsewherePresentsVenueRecord | null;
}

export const ListingDetail = ({
	event,
	programmeData,
	relatedEvents,
	space,
	elsewherePresentsVenue,
}: ListingDetailProps) => {
	const isElsewherePresents = event.elsewhere_presents;

	const relatedContentHeading = isElsewherePresents
		? 'More from Elsewhere Presents'
		: 'You might also like';

	return (
		<article
			className={styles['listing-detail']}
			itemScope
			itemType="https://schema.org/MusicEvent"
		>
			<ListingAdditionalMicrodata event={event} isWithDescription isWithUrl />
			<ListingDetailTopSection
				className={styles.section}
				event={event}
				programmeData={programmeData}
			/>
			<ListingDetailMiddleSection
				className={styles.section}
				elsewherePresentsVenue={elsewherePresentsVenue}
				isElsewherePresents={isElsewherePresents}
				programmeData={programmeData}
				space={space}
			/>
			{relatedEvents.length ? (
				<RelatedContent
					className={styles.section}
					heading={relatedContentHeading}
					isElsewherePresents={isElsewherePresents}
				>
					{relatedEvents.map((relatedEvent) => (
						<ListingThumbnail
							event={relatedEvent}
							headingTag="h3"
							key={relatedEvent.id}
							sizes="(min-width: 56.25em) 33.3333vw, 100vw"
						/>
					))}
				</RelatedContent>
			) : null}
		</article>
	);
};
